export default __webpack_public_path__ + "static/media/757.882cbbb1.png";